const GROUP_SELECTOR = '[data-dac-animation-group]';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const prepareTextItems = (group) => {
  if (group.dataset.dacAnimationAuto !== 'text') return;

  group.querySelectorAll('.text-block').forEach((item, index) => {
    const isHeading = item.matches('.h1, .h2, .h3, .h4, .h5, .h6') || item.querySelector('h1, h2, h3, h4, h5, h6');
    item.dataset.dacAnimationItem = isHeading ? 'heading' : '';
    item.style.setProperty('--dac-animation-order', index);
  });
};

const reveal = (group) => {
  window.requestAnimationFrame(() => group.classList.add('is-dac-animation-visible'));
};

const initializeGroup = (group) => {
  if (group.dataset.dacAnimationReady === 'true') return;

  group.dataset.dacAnimationReady = 'true';
  prepareTextItems(group);

  if (!group.querySelector('[data-dac-animation-item]')) return;

  group.classList.add('dac-animation-pending');

  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    reveal(group);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      reveal(group);
      observer.disconnect();
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.14,
    }
  );

  observer.observe(group);
};

const initializeAnimationGroups = (root = document) => {
  if (root.matches?.(GROUP_SELECTOR)) initializeGroup(root);
  root.querySelectorAll?.(GROUP_SELECTOR).forEach(initializeGroup);
};

initializeAnimationGroups();

document.addEventListener('shopify:section:load', (event) => {
  initializeAnimationGroups(event.target);
});
